<!--
 * @Desc: --- elementui单张图片或者视频上传 ---
 * @version: 1.0.0
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-21 16:27:01
 -->
<template>
  <div>
    <el-upload
      :action="urlAction+apiUrl"
      :accept="accept"
      :data="{folderName}"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :on-progress="handleOnProgress"
      :before-upload="beforeAvatarUpload"
      class="avatar-uploader"
    >
      <template v-if="accept === 'image/png, image/jpg, image/jpeg, image/gif'">
        <img v-if="uploadLink" :src="uploadLink" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon" />
      </template>
      <template v-else>
        <span v-if="uploadLink">{{ uploadLink.split('/')[uploadLink.split('/').length - 1] }}</span>
        <i v-else class="el-icon-plus avatar-uploader-icon" />
      </template>
    </el-upload>
    <el-progress v-if="progressFlag" :percentage="number" :show-text="false" />
    <el-link v-if="accept === 'video/*' && uploadLink" :href="uploadLink" type="primary" target="_blank">预览</el-link>
    <template v-else-if="accept === 'image/png, image/jpg, image/jpeg, image/gif' && uploadLink">
      <el-link :href="uploadLink" type="primary" target="_blank">预览</el-link>
      <el-link type="danger" target="_blank" @click="$emit('del')">删除</el-link>
    </template>

  </div>
</template>

<script>
import { compressUpload } from '@/utils'
export default {
  name: 'UploadComOne',
  props: {
    // 接口中额外参数
    folderName: {
      type: String,
      default: 'image'
    },
    // 选择的文件类型
    accept: {
      type: String,
      default: 'image/png, image/jpg, image/jpeg, image/gif'
    },
    // 接口返回的地址
    imageUrl: {
      type: String,
      default: null
    },
    apiUrl: {
      type: String,
      default: '/api/common/uploadApp'
    }
  },
  data() {
    return {
      urlAction: process.env.BASE_API,
      url_: process.env.OSS_API,
      uploadLink: null,
      number: 0,
      progressFlag: false
    }
  },
  watch: {
    imageUrl(newValue, oldValue) {
      console.log(newValue, '69-----------')
      this.uploadLink = newValue
    }
  },
  created() {
    this.uploadLink = this.imageUrl
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.uploadLink = res.Data
      this.back(this.uploadLink)
    },
    beforeAvatarUpload(file) {
      console.log(file)
      return new Promise((resolve, reject) => {
        const isLt2M = file.size / 1024 / 1024 < 200
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 200MB!')
          reject()
        }
        if (this.accept === 'image/png, image/jpg, image/jpeg, image/gif') {
          const image = new Image()
          image.src = URL.createObjectURL(file)
          image.onload = () => {
            const resultBlob = compressUpload(image, file)
            resolve(resultBlob)
          }
        } else {
          resolve(file)
        }
      })
    },
    handleOnProgress(event, file, fileList) {
      this.progressFlag = true
      this.number = event.percent
      if (event.percent === 100) {
        this.progressFlag = false
      }

      console.log(event, file, fileList)
    },
    back(data) {
      this.$emit('backData', data)
    }
  }
}
</script>

<style lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
